"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./AlertBanner.scss");
var Join_1 = require("../../../helpers/Functions/Join");
var AlertBanner = /** @class */ (function (_super) {
    __extends(AlertBanner, _super);
    function AlertBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.fadeOut = function () {
            _this.setState({ isFadingOut: true });
            setTimeout(function () { return _this.onClose(); }, 300);
        };
        _this.onClose = function () {
            _this.setState({ render: false });
            if (_this.props && _this.props.onClose) {
                _this.props.onClose();
            }
        };
        _this.formatImage = function (imgStr) {
            var imgSrc = "";
            var imgClass = "";
            var imgAlt = "";
            var imgStyle;
            if (imgStr.indexOf("src") !== -1) {
                imgSrc = imgStr.split('src="')[1] ? imgStr.split('src="')[1] : "";
                imgSrc = imgSrc.split('"')[0];
            }
            if (imgStr.indexOf("class") !== -1) {
                imgClass = imgStr.split('class="')[1] ? imgStr.split('class="')[1] : "";
                imgClass = imgClass.split('"')[0];
            }
            if (imgStr.indexOf("alt") !== -1) {
                imgAlt = imgStr.split('alt="')[1] ? imgStr.split('alt="')[1] : "";
                imgAlt = imgAlt.split('"')[0];
            }
            if (imgStr.indexOf("style") !== -1) {
                imgStyle = imgStr.split("style='")[1] ? imgStr.split("style='")[1] : "";
                imgStyle = JSON.parse(imgStyle.split("'")[0]);
            }
            return React.createElement("img", { src: imgSrc, alt: imgAlt, style: imgStyle, className: imgClass });
        };
        _this.state = {
            render: true,
            isFadingOut: false,
            icon: _this.props.icon,
        };
        return _this;
    }
    AlertBanner.prototype.render = function () {
        var wrapperClasses = this.props.className
            ? this.props.className
            : "bg-ui-background-gray";
        var btnColor = wrapperClasses.indexOf("bg-ui-background-gray") !== -1
            ? "color-ui-black"
            : "color-ui-white";
        var isIconImg = this.state.icon && typeof this.state.icon === "string" ? true : false;
        return this.state.render ? (React.createElement("div", { "data-testid": this.props.testId, className: Join_1.join(wrapperClasses, "max-width-container mar-b-xs", this.state.isFadingOut ? "fadeout" : "") },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: Join_1.join(isIconImg ? "flex-items-center" : "flex-items-top", "flex justify-center grid-col-8 grid-col-10-md centered pad-r-xl-sm pad-t-xs pad-b-xs") },
                        this.state.icon && isIconImg ? (this.formatImage(this.state.icon)) : typeof this.props.icon === "object" ? (React.createElement("div", { className: "width-md-all height-md-all mar-r-xs " + styles.flexShrink0 }, this.state.icon)) : null,
                        React.createElement("p", { className: Join_1.join(wrapperClasses.indexOf("bg-ui-background-gray") !== -1
                                ? "color-ui-black"
                                : "color-ui-white", "type-base line-h-md mar-b-none", this.state.icon ? "text-left" : "text-center", this.state.icon && !isIconImg ? "pad-t-xxxs" : "") }, this.props.children),
                        React.createElement("button", { "aria-label": "" + (this.props.closeAccessability
                                ? this.props.closeAccessability
                                : "Dismiss Alert"), className: "top right height-md-all width-md-all icon-close absolute " + btnColor, onClick: this.fadeOut })))))) : null;
    };
    return AlertBanner;
}(React.Component));
exports.default = AlertBanner;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/AlertBanner/AlertBanner.js
// module id = 1741
// module chunks = 8